export default "__VITE_ASSET__Di1DDJlY__ 100w";